interface Nameable {
  firstName?: string;
  nickname?: string | null;
}

export function preferredName(thing: Nameable | undefined) {
  return thing?.nickname || thing?.firstName || '';
}
